module.exports = __webpack_public_path__ + "static/media/use14_ch01.edaa6b3d.png";